import React from 'react';
import Link from 'gatsby-link';
import { css } from 'emotion';
import { Spring, config } from 'react-spring';
import styles from './project-breadcrumb.module.css';

const ProjectBreadcrumb = ({
  preTitle,
  title,
  color,
  isHome,
  returnSection,
}) => {
  const renderAwkwardOffice = () => {
    return (
      <React.Fragment>
        <span
          className={[
            styles.preTitle,
            css`
              color: ${color};
            `,
          ]}
        >
          The Employee Experience
        </span>
      </React.Fragment>
    );
  };

  const renderBlog = () => {
    return (
      <React.Fragment>
        <Link
          to="/blog"
          className={[
            styles.preTitle,
            styles.link,
            css`
              color: ${color};
            `,
          ].join(' ')}
        >
          Blog
        </Link>
      </React.Fragment>
    );
  };

  const renderOurService = () => {
    return (
      <React.Fragment>
        <Link
          to="/capabilities"
          className={[styles.preTitle, styles.link].join(' ')}
        >
          Capabilities
        </Link>
      </React.Fragment>
    );
  };

  const renderCareers = () => {
    return (
      <React.Fragment>
        <span className={styles.preTitle}>Careers</span>
      </React.Fragment>
    );
  };

  const renderSales = () => {
    return (
      <React.Fragment>
        <span className={styles.preTitle}>Project snapshots</span>
      </React.Fragment>
    );
  };

  const renderCareer = () => {
    return (
      <React.Fragment>
        <Link
          to="/careers"
          className={[
            styles.preTitle,
            styles.link,
            css`
              color: ${color};
            `,
          ].join(' ')}
        >
          Careers
        </Link>
      </React.Fragment>
    );
  };

  const renderInternships = () => {
    return (
      <React.Fragment>
        <Link
          to="/internships"
          className={[
            styles.preTitle,
            styles.link,
            css`
              color: ${color};
            `,
          ].join(' ')}
        >
          Internships
        </Link>
      </React.Fragment>
    );
  };

  const renderAbout = () => {
    return (
      <React.Fragment>
        <span className={styles.preTitle}>About Us</span>
      </React.Fragment>
    );
  };

  const renderBranding = () => {
    return (
      <React.Fragment>
        <span className={styles.preTitle}>Super charge your brand</span>
      </React.Fragment>
    );
  };

  const renderOurWork = () => {
    return (
      <React.Fragment>
        <Link
          to="/our-work"
          className={[styles.preTitle, styles.link].join(' ')}
        >
          Our Work
        </Link>
      </React.Fragment>
    );
  };

  const renderCapabilities = () => {
    return (
      <React.Fragment>
        <span className={styles.preTitle}>Capabilities</span>
      </React.Fragment>
    );
  };

  const renderPreTitle = () => {
    switch (preTitle) {
      case 'about':
        return renderAbout();
      case 'awkwardoffice':
        return renderAwkwardOffice();
      case 'blog':
        return renderBlog();
        break;
      case 'branding':
        return renderBranding();
        break;
      case 'capabilities':
        return renderCapabilities();
      case 'career':
        return renderCareer();
        break;
      case 'careers':
        return renderCareers();
        break;
      case 'internships':
        return renderInternships();
        break;
      case 'our-work':
        return renderOurWork();
        break;
      case 'our-service':
        return renderOurService();
        break;
      case 'salesenablement':
        return renderSales();
        break;
      default:
        break;
    }
  };

  const showTitle = preTitle => {
    switch (preTitle) {
      case 'awkwardoffice':
        return false;
      case 'branding':
        return false;
        break;
      case 'careers':
        return false;
        break;
      case 'internships':
        return false;
        break;
      case 'about':
        return false;
        break;
      case 'capabilities':
        return false;
      case 'salesenablement':
        return false;
      default:
        return true;
    }
  };

  const renderDash = animation => {
    return (
      <span
        className={[
          styles.dash,
          css`
            background: ${color};
          `,
        ].join(' ')}
        style={animation}
      />
    );
  };

  const renderTitle = animation => {
    return (
      <div
        className={styles.pageTitle}
        dangerouslySetInnerHTML={{ __html: title }}
        style={animation}
      />
    );
  };

  const renderDefaultAnimation = () => {
    return (
      <div>
        <h5 className={styles.title} style={{ color: color }}>
          {renderPreTitle()}
          <Spring from={{ width: '10px' }} to={{ width: '18px' }} delay={400}>
            {animation => renderDash(animation)}
          </Spring>
          {showTitle(preTitle) && (
            <Spring
              from={{ opacity: 0 }}
              to={{ opacity: 1 }}
              delay={800}
              config={{ tension: 180, friction: 60 }}
            >
              {animation => renderTitle(animation)}
            </Spring>
          )}
        </h5>
      </div>
    );
  };

  const renderHomeAnimation = () => {
    return (
      <div>
        <h5 className={styles.title} style={{ color: color }}>
          {renderPreTitle()}
          <Spring
            from={{ width: '10px' }}
            to={{ width: returnSection === 'active' ? '18px' : '10px' }}
            delay={400}
          >
            {animation => renderDash(animation)}
          </Spring>
          {showTitle(preTitle) && (
            <Spring
              from={{ opacity: 0 }}
              to={{ opacity: returnSection === 'active' ? 1 : 0 }}
              delay={800}
              config={{ tension: 180, friction: 60 }}
            >
              {animation => renderTitle(animation)}
            </Spring>
          )}
        </h5>
      </div>
    );
  };

  if (isHome !== true) {
    return renderDefaultAnimation();
  } else {
    return renderHomeAnimation();
  }
};

export default ProjectBreadcrumb;



// WEBPACK FOOTER //
// ./src/components/project/project-hero/project-breadcrumb/index.js